import React, { forwardRef } from "react";
import { cn } from "../../lib/utils.js";

/* ---------------- Kbd ---------------- */

/* `size` is md (default, today's box) or sm (18px, the box VSM builds today
   via className). Size classes apply before className, so an explicit
   min-w, h or px override on className still wins (Avatar's contract). */
const KBD_SIZE = {
  md: "min-w-[1.4rem] h-5 px-1.5",
  sm: "min-w-4.5 h-4.5 px-1",
} as const;

export type KbdSize = keyof typeof KBD_SIZE;

export interface KbdProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  size?: KbdSize;
}

export const Kbd = forwardRef<HTMLElement, KbdProps>(function Kbd(
  { children, size = "md", className, ...rest },
  ref,
) {
  return (
    <kbd
      ref={ref}
      className={cn(
        "inline-flex items-center justify-center rounded border border-pb-border bg-pb-card-elevated text-dense-2 font-mono font-medium text-pb-text-secondary pb-hairline",
        KBD_SIZE[size],
        className,
      )}
      {...rest}
    >
      {children}
    </kbd>
  );
});
